import Swal from 'sweetalert2';
import { t } from 'i18next';

/** Exibe alertas com SweetAlert2; com timer, fecha sozinho. */

function showTitle(type: string) {
    switch (type) {
        case 'success':
            return t('general.sucesso');
        case 'error':
            return t('general.erro');
        case 'warning':
            return t('general.atencao');
        case 'info':
            return t('general.informacao');
        case 'question':
            return '';
        default:
            break;
    }
}

export const showAlert = (
    message: string,
    type: 'success' | 'error' | 'warning' | 'info' | 'question',
    timer?: number,
    darkMode?: boolean
): void => {
    const effectiveTimer = type === 'error' ? undefined : timer;

    Swal.fire({
        title: `<h3 style="color: ${
            type === 'success'
                ? '#83c444'
                : type === 'error'
                ? '#df4343'
                : type === 'info'
                ? '#2a84eb'
                : type === 'warning'
                ? '#ddaf16'
                : ''
        };"><strong>${showTitle(type)}</strong></h3>`,
        html: `<h3>${message}<h3>`,
        icon: type,
        timer: effectiveTimer || undefined,
        showConfirmButton: !effectiveTimer, // Sem timer, o usuário fecha pelo botão
        confirmButtonText: t('general.fechar'),
        confirmButtonColor: '#2a84eb',
        timerProgressBar: !!effectiveTimer,
        showCloseButton: true,
        background: darkMode ? '#141c2b' : '#ffffff',
        color: darkMode ? '#ffffff' : '#333333',
        willOpen: () => {
            const progressBar = document.querySelector<HTMLElement>('.swal2-timer-progress-bar');
            if (progressBar) {
                progressBar.style.backgroundColor =
                    type === 'success' ? '#83c444' : '';
            }
        },
            // Pause timer on hover
        didOpen: (popup) => {
            popup.addEventListener('mouseenter', () => {
                Swal.stopTimer();
            // Resume timer when mouse leaves
            });
            popup.addEventListener('mouseleave', () => {
                Swal.resumeTimer();
            });
        }
    });
};
